<template>
  <section class="page">
    <div class="page__content">
      <!-- 4 раздел.  Силы и средства -->
      <div v-if="activeSection === '4'" class="section-card" :data-date="selectedISO">
        <div class="section-header">
          <h3 class="section-title">{{ $t('kps.calendar.sec4Title') }}</h3>
          <div class="section-header-actions">
            <!-- По ТЗ 14.09.2026: явная кнопка обновления, чтобы числа
                 совпадали с 5-б после чистки данных (без hard reload). -->
            <ActionButton :outlined="true" :borderColor="'#111827'" :text="'↻ ' + $t('common.refresh')" @click="fetchForces" />
            <ActionButton v-if="!readOnly" :outlined="true" :borderColor="'#111827'" :text="$t('kps.absences.openManage')" @click="absencesModalOpen = true" />
          </div>
        </div>
        <div class="section-body">
          <p v-if="forcesLoading" class="muted">{{ $t('common.loadingData') }}</p>
          <p v-else-if="forcesError" class="error">{{ $t('common.error') }}: {{ forcesError }}</p>
          <template v-else>
            <DataTable
              :columns="forcesTableColumns"
              :rows="forcesRows"
              :row-key="r => r.__id || r.group"
              :row-height="56"
            >
              <template #cell-group="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.group }}</div>
                <input v-else class="tbl-input" v-model="row.group" />
              </template>
              
              <template #cell-officers="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.officers }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.officers" />
              </template>
              <template #cell-contract="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.contract }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.contract" />
              </template>
              <template #cell-conscripts="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.conscripts }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.conscripts" />
              </template>
              <template #cell-workers="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.workers }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.workers" />
              </template>
              <template #cell-others="{ row }">
                <div class="cell-text">{{ row.values.others }}</div>
              </template>
              <template #cell-dogs="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.dogs }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.dogs" />
              </template>
              <template #cell-horses="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.horses }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.horses" />
              </template>
              <template #cell-vehicles="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.vehicles }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.vehicles" />
              </template>
              <template #cell-radars="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.radars }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.radars" />
              </template>
              <template #cell-spots="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.spots }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.spots" />
              </template>
              <template #cell-boats="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.boats }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.boats" />
              </template>
              <template #cell-optics="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.values.optics }}</div>
                <input v-else class="tbl-input" type="number" min="0" v-model.number="row.values.optics" />
              </template>
              <template #cell-uav="{ row }">
                <div class="cell-text">{{ row.values.uav }}</div>
              </template>
              <!-- Убрали actions - только читаемая таблица -->
            </DataTable>
            <!-- <div style="margin-top: 8px; display: flex; justify-content: flex-end;">
              <ActionButton v-if="!readOnly" :color="'#2A8A1B'" :text="$t('kps.calendar.addGroup')" @click="addForcesRow" />
            </div> -->
          </template>
        </div>
      </div>

      <!-- 5-а: textarea -->
      <div v-if="activeSection === '5'" class="section-card" :data-date="selectedISO">
        <div class="section-header">
          <h3 class="section-title">{{ $t('kps.calendar.sec5aTitle') }}</h3>
        </div>
        <div class="section-body">
          <p v-if="briefLoading" class="muted">{{ $t('common.loadingData') }}</p>
          <p v-else-if="briefError" class="error">{{ $t('common.error') }}: {{ briefError }}</p>
          <template v-else>
            <div class="brief-editor">
              <template v-if="!briefEditing">
                <pre class="brief-view">{{ briefTextArea }}</pre>
              </template>
              <template v-else>
                <textarea class="brief-textarea" v-model="briefTextArea" rows="6" :placeholder="$t('kps.calendar.sec5aPlaceholder')"></textarea>
              </template>
              <div v-if="!readOnly" class="brief-actions">
                <ActionButton v-if="!briefEditing" :outlined="true" :borderColor="'#111827'" :text="$t('common.edit')" @click="startEditBrief" />
                <template v-else>
                  <ActionButton :color="'#2A8A1B'" :text="$t('common.save')" @click="saveBrief" />
                  <ActionButton :outlined="true" :borderColor="'#111827'" :text="$t('common.cancel')" @click="cancelBrief" />
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- 5-б: таблица пунктов приказа -->
      <div v-if="activeSection === '5'" class="section-card" :data-date="selectedISO">
        <div class="section-header">
          <h3 class="section-title">{{ $t('kps.calendar.sec5bTitle') }}</h3>
        </div>
        <div class="section-body">
          <p v-if="orderLoading" class="muted">{{ $t('common.loadingData') }}</p>
          <p v-else-if="orderError" class="error">{{ $t('common.error') }}: {{ orderError }}</p>
          <template v-else>
            <DataTable
              :columns="orderColumnsExt"
              :rows="orderRows"
              :row-key="r => r.__id || r.id"
              :row-height-by-row="orderRowHeight"
            >
              <template #cell-composition="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.composition }}</div>
                <input v-else class="tbl-input" v-model="row.composition" />
              </template>
              <template #cell-type="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.type }}</div>
                <SelectField v-else v-model="row.type" :options="dutyTypeOptions" :searchable="true" :placeholder="$t('kps.calendar.dutyTypePh')" />
              </template>
              <template #cell-reinforcement="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.reinforcement }}</div>
                <input v-else class="tbl-input" v-model="row.reinforcement" />
              </template>
              <template #cell-area="{ row }">
                <div v-if="!row.editing" class="cell-text">{{ row.area }}</div>
                <input v-else class="tbl-input" v-model="row.area" />
              </template>
              <template #cell-time="{ row }">
                <div v-if="!row.editing" class="cell-text">
                  <template v-if="row.timeFrom && row.timeTo">{{ row.timeFrom }} - {{ row.timeTo }}</template>
                  <template v-else>{{ row.time }}</template>
                </div>
                <div v-else class="time-range">
                  <label class="time-field">
                    <span>{{ $t('kps.calendar.fromLabel') }}</span>
                    <MaskedInput v-model="row.timeFrom" mask="##:##" :placeholder="$t('kps.calendar.timeMask')" />
                  </label>
                  <label class="time-field">
                    <span>{{ $t('kps.calendar.toLabel') }}</span>
                    <MaskedInput v-model="row.timeTo" mask="##:##" :placeholder="$t('kps.calendar.timeMask')" />
                  </label>
                </div>
              </template>
              <template #head-actions>
                <div class="tbl__header-text" style="justify-content: flex-end; text-align: right; width: 100%;"></div>
              </template>
              <template #cell-actions="{ row }">
                <div v-if="!readOnly" class="actions">
                  <button v-if="!row.editing" class="actions__btn actions__btn--edit" @click="onEdit(row, 'orderRows')" :title="$t('common.edit')" :aria-label="$t('common.edit')">
                    <img class="actions__icon" src="../../assets/images/edit.svg" alt="edit" />
                  </button>
                  <template v-else>
                    <button class="actions__btn actions__btn--accept" @click="onAccept(row, 'orderRows')" :title="$t('common.save')" :aria-label="$t('common.save')">
                      <img class="actions__icon" src="../../assets/images/accept.svg" alt="accept" />
                    </button>
                    <button class="actions__btn actions__btn--decline" @click="onDecline(row)" :title="$t('common.cancel')" :aria-label="$t('common.cancel')">
                      <img class="actions__icon" src="../../assets/images/decline.svg" alt="decline" />
                    </button>
                  </template>
                  <button class="actions__btn actions__btn--delete" @click="onDelete(row, 'orderRows')" :title="$t('common.delete')" :aria-label="$t('common.delete')">
                    <img class="actions__icon" src="../../assets/images/markdown/trash.svg" alt="delete" />
                  </button>
                </div>
              </template>
            </DataTable>
            <!-- <div style="margin-top: 8px; display: flex; justify-content: flex-end;">
              <ActionButton v-if="!readOnly" :color="'#2A8A1B'" :text="$t('kps.calendar.addOrderRow')" @click="addOrderRow" />
            </div> -->
          </template>
        </div>
      </div>

      <!-- 5-в: пробег ТС и пайки -->
      <div v-if="activeSection === '5'" class="section-card" :data-date="selectedISO">
        <div class="section-header">
          <h3 class="section-title">{{ $t('kps.calendar.sec5cTitle') }}</h3>
        </div>
        <div class="section-body">
          <p v-if="mileageLoading" class="muted">{{ $t('common.loadingData') }}</p>
          <p v-else-if="mileageError" class="error">{{ $t('common.error') }}: {{ mileageError }}</p>
          <template v-else>
            <div class="run-wrap">
              <DataTable
                :columns="runColumnsExt"
                :rows="runRows"
                :row-key="r => r.__id || r.id"
                :row-height="56"
              >
                <template #cell-vehicle_type="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ getOptionLabel(vehicleTypeOptions, row.vehicle_type) }}</div>
                  <SelectField v-else v-model="row.vehicle_type" :options="vehicleTypeOptions" :placeholder="$t('kps.calendar.vehiclePh')" />
                </template>
                <template #cell-plate="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ row.plate }}</div>
                  <input v-else class="tbl-input" v-model="row.plate" :placeholder="$t('kps.calendar.platePh')" />
                </template>
                <template #cell-distance="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ row.distance }}</div>
                  <input v-else class="tbl-input" v-model.number="row.distance" type="number" min="0" />
                </template>
                <template #cell-note="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ row.note }}</div>
                  <input v-else class="tbl-input" v-model="row.note" />
                </template>
                <template #head-actions>
                  <div class="tbl__header-text" style="justify-content: flex-end; text-align: right; width: 100%;"></div>
                </template>
                <template #cell-actions="{ row }">
                  <div v-if="!readOnly" class="actions">
                    <button v-if="!row.editing" class="actions__btn actions__btn--edit" @click="onEdit(row, 'runRows')" :title="$t('common.edit')" :aria-label="$t('common.edit')">
                      <img class="actions__icon" src="../../assets/images/edit.svg" alt="edit" />
                    </button>
                    <template v-else>
                      <button class="actions__btn actions__btn--accept" @click="onAccept(row, 'runRows')" :title="$t('common.save')" :aria-label="$t('common.save')">
                        <img class="actions__icon" src="../../assets/images/accept.svg" alt="accept" />
                      </button>
                      <button class="actions__btn actions__btn--decline" @click="onDecline(row)" :title="$t('common.cancel')" :aria-label="$t('common.cancel')">
                        <img class="actions__icon" src="../../assets/images/decline.svg" alt="decline" />
                      </button>
                    </template>
                    <!-- <button class="actions__btn actions__btn--delete" @click="onDelete(row, 'runRows')" title="Удалить" aria-label="Удалить">
                      <img class="actions__icon" src="../../assets/images/markdown/trash.svg" alt="delete" />
                    </button> -->
                  </div>
                </template>
              </DataTable>
              <!-- <div style="margin-top: 8px; display: flex; justify-content: flex-end;">
                <ActionButton v-if="!readOnly" :color="'#2A8A1B'" :text="$t('kps.calendar.addVehicle')" @click="addRunRow" />
              </div> -->
            </div>

            <div class="ration-wrap">
              <DataTable
                :columns="rationColumnsExt"
                :rows="rationRows"
                :row-key="r => r.__id || r.id"
                :row-height="56"
              >
                <template #cell-name="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ row.name }}</div>
                  <SelectField v-else v-model="row.mealId" :options="allMeals.map(m => ({ value: m.id, label: m.name }))" :placeholder="$t('kps.calendar.mealPh')" />
                </template>
                <template #cell-qty="{ row }">
                  <div v-if="!row.editing" class="cell-text">{{ row.qty }}</div>
                  <input v-else class="tbl-input" v-model.number="row.qty" type="number" min="0" />
                </template>
                <template #head-actions>
                  <div class="tbl__header-text" style="justify-content: flex-end; text-align: right; width: 100%;"></div>
                </template>
                <template #cell-actions="{ row }">
                  <div v-if="!readOnly" class="actions">
                    <button v-if="!row.editing" class="actions__btn actions__btn--edit" @click="onEdit(row, 'rationRows')" :title="$t('common.edit')" :aria-label="$t('common.edit')">
                      <img class="actions__icon" src="../../assets/images/edit.svg" alt="edit" />
                    </button>
                    <template v-else>
                      <button class="actions__btn actions__btn--accept" @click="onAccept(row, 'rationRows')" :title="$t('common.save')" :aria-label="$t('common.save')">
                        <img class="actions__icon" src="../../assets/images/accept.svg" alt="accept" />
                      </button>
                      <button class="actions__btn actions__btn--decline" @click="onDecline(row)" :title="$t('common.cancel')" :aria-label="$t('common.cancel')">
                        <img class="actions__icon" src="../../assets/images/decline.svg" alt="decline" />
                      </button>
                    </template>
                    <!-- <button class="actions__btn actions__btn--delete" @click="onDelete(row, 'rationRows')" title="Удалить" aria-label="Удалить">
                      <img class="actions__icon" src="../../assets/images/markdown/trash.svg" alt="delete" />
                    </button> -->
                  </div>
                </template>
              </DataTable>
              <!-- <div style="margin-top: 8px; display: flex; justify-content: flex-end;">
                <ActionButton v-if="!readOnly" :color="'#2A8A1B'" :text="$t('kps.calendar.addMeal')" @click="addRationRow" />
              </div> -->
            </div>
          </template>
        </div>
      </div>

      <div v-if="activeSection === '6'" class="section-card" :data-date="selectedISO">
        <div class="section-header">
          <h3 class="section-title">{{ $t('kps.calendar.sec6Title') }}</h3>
        </div>
        <div class="section-body">
          <div v-if="sec6Loading" class="muted">{{ $t('common.loading') }}</div>
          <div v-else-if="sec6Error" class="error">{{ $t('common.error') }}: {{ sec6Error }}</div>

          <div v-else class="sec6-list">
            <div v-if="!sec6Entries.length" class="muted">{{ $t('common.noRecordsForDate') }}</div>
            <div v-for="entry in sec6Entries" :key="entry.__id || entry.id" class="sec6-entry">
              <div class="sec6-entry__top">
                <div class="sec6-entry__field">
                  <template v-if="entry.editing">
                    <SelectField v-model="entry.checkTypeId" :options="sec6CheckOptions" :searchable="true" :placeholder="$t('kps.calendar.sec6TypePh')" />
                  </template>
                  <template v-else>
                    <div class="sec6-field-box">
                      <div class="sec6-field-box__text">{{ getOptionLabel(sec6CheckOptions, entry.checkTypeId) || entry.checkTypeId }}</div>
                      <div class="sec6-field-box__icon"></div>
                    </div>
                  </template>
                </div>

                <div class="sec6-entry__field">
                  <template v-if="entry.editing">
                    <SelectField class="sec6-time-select" v-model="entry.time" :options="sec6TimeOptions" :placeholder="$t('kps.calendar.sec6TimePh')" />
                  </template>
                  <template v-else>
                    <div class="sec6-field-box">
                      <div class="sec6-field-box__text">{{ entry.time || '—' }}</div>
                      <div class="sec6-field-box__icon"></div>
                    </div>
                  </template>
                </div>

                <div class="sec6-entry__field">
                  <template v-if="entry.editing">
                    <SelectField v-model="entry.square" :options="sec6SquareOptions" :searchable="true" :placeholder="$t('kps.calendar.sec6SquarePh')" />
                  </template>
                  <template v-else>
                    <div class="sec6-field-box">
                      <div class="sec6-field-box__text">{{ getOptionLabel(sec6SquareOptions, entry.square) }}</div>
                      <div class="sec6-field-box__icon"></div>
                    </div>
                  </template>
                </div>

                <div class="sec6-entry__field">
                  <template v-if="entry.editing">
                    <SelectField v-model="entry.patrolType" :options="sec6PatrolTypeOptions" :searchable="true" :placeholder="$t('kps.calendar.sec6PatrolPh')" />
                  </template>
                  <template v-else>
                    <div class="sec6-field-box">
                      <div class="sec6-field-box__text">{{ getOptionLabel(sec6PatrolTypeOptions, entry.patrolType) }}</div>
                      <div class="sec6-field-box__icon"></div>
                    </div>
                  </template>
                </div>
              </div>

              <div class="sec6-entry__bottom">
                <template v-if="entry.editing">
                  <textarea class="brief-textarea" v-model="entry.text" rows="6" :placeholder="$t('kps.calendar.sec6TextPh')"></textarea>
                </template>
                <template v-else>
                  <pre class="brief-view">{{ entry.text || '—' }}</pre>
                </template>

                <div v-if="!readOnly" class="sec6-entry__bottom-actions">
                  <template v-if="!entry.editing">
                    <template v-if="canEditSec6">
                      <button class="actions__btn actions__btn--edit" :title="$t('common.edit')" :aria-label="$t('common.edit')" @click="startEditSec6Entry(entry)">
                        <img class="actions__icon" src="../../assets/images/edit.svg" alt="edit" />
                      </button>
                      <button class="actions__btn actions__btn--delete" :title="$t('common.delete')" :aria-label="$t('common.delete')" @click="onDeleteSec6Entry(entry)" :disabled="entry.saving">
                        <img class="actions__icon" src="../../assets/images/markdown/trash.svg" alt="delete" />
                      </button>
                    </template>
                  </template>
                  <template v-else>
                    <button class="actions__btn actions__btn--accept" :title="$t('common.save')" :aria-label="$t('common.save')" @click="saveSec6Entry(entry)">
                      <img class="actions__icon" src="../../assets/images/accept.svg" alt="accept" />
                    </button>
                    <button class="actions__btn actions__btn--decline" :title="$t('common.cancel')" :aria-label="$t('common.cancel')" @click="cancelSec6Entry(entry)">
                      <img class="actions__icon" src="../../assets/images/decline.svg" alt="decline" />
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canEditSec6" style="margin-top: 8px; display: flex; justify-content: flex-end;">
          <ActionButton v-if="!readOnly" :color="'#2A8A1B'" :text="$t('kps.calendar.sec6AddRecord')" @click="addSec6Entry" />
        </div>
      </div>

    </div>

    <div class="page__footer">
      <ViewNavButtons
          :prev-text="$t('common.back')"
          :next-text="$t('common.next')"
          :prev-to="{ path: '/kps/orders' }"
          :next-to="{ path: '/kps/officers-work' }"
      />
    </div>

    <AbsencesModal
      :open="absencesModalOpen"
      :date-i-s-o="selectedISO"
      @close="absencesModalOpen = false"
      @changed="fetchForces"
    />
  </section>
</template>

<script>
import ViewNavButtons from '@/components/navigation/ViewNavButtons.vue'
import DataTable from '@/components/table/DataTable.vue'
import MaskedInput from '@/components/widgets/MaskedInput.vue'
import SelectField from '@/components/widgets/SelectField.vue'
import ActionButton from '@/components/widgets/ActionButton.vue'
import { ensureCurrentUser, getCachedCurrentUser } from '@/api/user'
import { canEditKpsSection6 } from '@/access/armAccess'
import { checkOrCreateBookByDate } from '@/api/book'
import { invalidateBookContext } from '@/api/http'
import { listConclusions, createConclusion, updateConclusion } from '@/api/conclusions'
import { listVehicleRecords, deleteVehicleRecord } from '@/api/vehicleRecords'
import { listMealRecords, createMealRecord, updateMealRecord, deleteMealRecord } from '@/api/mealRecords'
import { getSection6Entries, saveSection6Entry, deleteSection6Entry } from '@/api/kpsCalendar'
import { createOrUpdateVehicleRecordWithName, createOrGetMealByName, vehiclesApi, mealsApi } from '@/api/warehouse'
import { createVehicleRecord, updateVehicleRecord } from '@/api/vehicleRecords'
import { listChpoOrdersToSquads, createChpoOrderToSquad, updateChpoOrderToSquad, deleteChpoOrderToSquad } from '@/api/chpoOrdersToSquads'
import AbsencesModal from '@/components/modals/AbsencesModal.vue'

export default {
  name: 'KpsCalendarView',
  components: { ViewNavButtons, DataTable, MaskedInput, SelectField, ActionButton, AbsencesModal },
  props: {
    section: { type: String, default: '' },
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const startYear = now.getFullYear() - 5
    const endYear = now.getFullYear() + 5
    return {
      currentUser: null,
      days: [],
      viewDate: new Date(today.getFullYear(), today.getMonth(), 1),
      selectedDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      yearOptions: Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i),
      selectedMonth: today.getMonth(),
      selectedYear: today.getFullYear(),

      allVehicles: [],
      allMeals: [],
      // Список видов п/н (как в PlanView)
      dutyTypeOptions: ['Д', 'ЧГ', 'ЧЗ', 'ЧОО', 'ЧП', 'С', 'ПН', 'ПТН', 'РЛП', 'ПРП', 'ПП', 'КРП', 'РПГ', 'ТГ', 'ПГ', 'Зн', 'Зс', 'ПК', 'РГГ', 'ДСС', 'ДОТН', 'ДЖ', 'ПП']
        .map(v => ({ value: v, label: v })),

      forcesLoading: false,
      forcesError: null,
      forcesRows: [],
      absencesModalOpen: false,

      briefLoading: false,
      briefError: null,
      orderLoading: false,
      orderError: null,
      orderRows: [],
      mileageLoading: false,
      mileageError: null,
      runRows: [],
      rationRows: [],

      sec6Loading: false,
      sec6Error: null,
      sec6Entries: [],
      sec6TimeOptions: Array.from({ length: 24 }, (_, h) => {
        const hh = h < 10 ? `0${h}` : `${h}`
        const v = `${hh}:00`
        return { value: v, label: v }
      }),
      sec6SquareOptions: (() => {
        const letters = ['А','Б','В','Г','Д','Е']
        const out = []
        for (const L of letters) {
          for (let i = 1; i <= 10; i++) {
            const val = `${L}${i}`
            out.push({ value: val, label: val })
          }
        }
        return out
      })(),

      briefEditing: false,
      briefTextArea: '',
      briefBackup: '',

      dateMaskStr: '',
      bookId: null,
      // IDs для сущностей, которые редактируются как одиночные (5-а)
      briefId: null,
      // сохранённый полный объект контекста book/check для выбранной даты
      bookContext: null,
    }
  },
  computed: {
    armUser() {
      return this.currentUser || getCachedCurrentUser();
    },
    canEditSec6() {
      return canEditKpsSection6(this.armUser);
    },
    monthOptions() {
      const m = this.$t
      return [
        { value: 0, label: m('kps.calendar.months.jan') },
        { value: 1, label: m('kps.calendar.months.feb') },
        { value: 2, label: m('kps.calendar.months.mar') },
        { value: 3, label: m('kps.calendar.months.apr') },
        { value: 4, label: m('kps.calendar.months.may') },
        { value: 5, label: m('kps.calendar.months.jun') },
        { value: 6, label: m('kps.calendar.months.jul') },
        { value: 7, label: m('kps.calendar.months.aug') },
        { value: 8, label: m('kps.calendar.months.sep') },
        { value: 9, label: m('kps.calendar.months.oct') },
        { value: 10, label: m('kps.calendar.months.nov') },
        { value: 11, label: m('kps.calendar.months.dec') },
      ]
    },
    vehicleTypeOptions() {
      return [
        { value: 1, label: this.$t('kps.calendar.vehicleTypes.car') },
        { value: 2, label: this.$t('kps.calendar.vehicleTypes.truck') },
        { value: 3, label: this.$t('kps.calendar.vehicleTypes.tractor') },
      ]
    },
    sec6CheckOptions() {
      return [
        { value: 1, label: this.$t('kps.calendar.checkTypes.checkPatrol') },
        { value: 2, label: this.$t('kps.calendar.checkTypes.checkKsp') },
        { value: 3, label: this.$t('kps.calendar.checkTypes.checkBorderLine') },
        { value: 4, label: this.$t('kps.calendar.checkTypes.checkRear') },
        { value: 5, label: this.$t('kps.calendar.checkTypes.patrolResults') },
        { value: 6, label: this.$t('kps.calendar.checkTypes.workDd') },
        { value: 7, label: this.$t('kps.calendar.checkTypes.tgTrip') },
        { value: 8, label: this.$t('kps.calendar.checkTypes.infoJournal') },
        { value: 9, label: this.$t('kps.calendar.checkTypes.vdViolations') },
      ]
    },
    sec6PatrolTypeOptions() {
      const codes = ['Д', 'ЧГ', 'ЧЗ', 'ЧОО', 'ЧП', 'С', 'ПН', 'ПТН', 'РЛП', 'ПРП', 'ПП', 'КРП', 'РПГ', 'ТГ', 'ПГ', 'Зн', 'Зс', 'ПК', 'РГГ', 'ДСС', 'ДОТН', 'ДЖ', 'ПП']
      return codes.map(v => ({ value: v, label: v }))
        .concat([{ value: 'other', label: this.$t('kps.calendar.otherTasks') }])
    },
    forcesTableColumns() {
      return [
        { key: 'group', label: this.$t('kps.calendar.colGroup'), width: 160 },
        { key: 'officers',  label: this.$t('kps.calendar.colOfficers'), width: 120 },
        { key: 'contract',  label: this.$t('kps.calendar.colContract'), width: 140 },
        { key: 'conscripts',label: this.$t('kps.calendar.colConscripts'), width: 120 },
        { key: 'workers',   label: this.$t('kps.calendar.colWorkers'), width: 160 },
        // По ТЗ 09.09.2026: 5-й бакет для юзеров с категорией вне 4 основных
        // (Активный состав / Резерв / NULL) — иначе они выпадали из подсчёта.
        { key: 'others',    label: this.$t('kps.calendar.colOthers'), width: 120 },
        { key: 'dogs',      label: this.$t('kps.calendar.colDogs'), width: 160 },
        { key: 'horses',    label: this.$t('kps.calendar.colHorses'), width: 120 },
        { key: 'vehicles',  label: this.$t('kps.calendar.colVehicles'), width: 160 },
        { key: 'radars',    label: this.$t('kps.calendar.colRadars'), width: 180 },
        { key: 'spots',     label: this.$t('kps.calendar.colSpots'), width: 180 },
        { key: 'boats',     label: this.$t('kps.calendar.colBoats'), width: 140 },
        { key: 'optics',    label: this.$t('kps.calendar.colOptics'), width: 210 },
        { key: 'uav',       label: this.$t('kps.calendar.colUav'), width: 140 },
      ]
    },
    orderColumnsExt() {
      return [
        { key: 'composition',  label: this.$t('kps.calendar.colComposition'), width: 210, flex: true },
        { key: 'type',         label: this.$t('kps.calendar.colDutyType'),    width: 120 },
        { key: 'reinforcement',label: this.$t('kps.calendar.colReinforcement'),width: 180 },
        { key: 'area',         label: this.$t('kps.calendar.colArea'),        width: 180 },
        { key: 'time',         label: this.$t('kps.calendar.colTime'),        width: 180 },
        { key: 'actions',      label: '',                                     width: 100 },
      ]
    },
    runColumnsExt() {
      return [
        { key: 'vehicle_type', label: this.$t('kps.calendar.colVehicleType'), width: 180 },
        { key: 'plate',        label: this.$t('kps.calendar.colPlate'),       width: 240 },
        { key: 'distance',     label: this.$t('kps.calendar.colDistance'),    width: 140 },
        { key: 'note',         label: this.$t('kps.calendar.colNote'),        width: 220 },
        { key: 'actions',      label: '',                                     width: 160 },
      ]
    },
    rationColumnsExt() {
      return [
        { key: 'name', label: this.$t('kps.calendar.colMealName'), width: 240 },
        { key: 'qty',  label: this.$t('kps.calendar.colMealQty'),  width: 140 },
        { key: 'actions', label: '',                                width: 140 },
      ]
    },
    activeSection() {
      if (['4', '5', '6'].includes(this.section)) return this.section;
      const q = this.$route.query.section;
      return ['4', '5', '6'].includes(q) ? q : '4';
    },
    selectedLabel() {
      const d = this.selectedDate
      return `${this.two(d.getDate())}.${this.two(d.getMonth()+1)}.${d.getFullYear()}`
    },
    selectedISO() {
      const d = this.selectedDate
      return `${d.getFullYear()}-${this.two(d.getMonth()+1)}-${this.two(d.getDate())}`
    },
  },
  mounted() {
    this.loadCurrentUser()
    this.initDays()
    this.dateMaskStr = this.formatDateRU(this.selectedDate)
    // последовательно загрузим данные по выбранной дате
    this.fetchForces()
    this.fetchBrief()
    this.fetchOrderPoints()
    this.fetchMileage()
    this.fetchSection6()
  },
  watch: {
    selectedDate() {
      this.dateMaskStr = this.formatDateRU(this.selectedDate)
      this.fetchForces()
      this.fetchBrief()
      this.fetchOrderPoints()
      this.fetchMileage()
      this.fetchSection6()
    },
  },
  methods: {
    async loadCurrentUser() {
      try {
        this.currentUser = await ensureCurrentUser();
      } catch {
        this.currentUser = getCachedCurrentUser();
      }
    },
    // === УТИЛИТЫ ДАТ/НАВИГАЦИИ (восстановлены) ===
    two(n) { return n < 10 ? `0${n}` : String(n) },
    monthName(d) {
      const m = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь']
      return m[d.getMonth()]
    },
    weekdayShort(d) {
      const w = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
      return w[d.getDay()]
    },
    isToday(d) {
      const n = new Date();
      const today = new Date(n.getFullYear(), n.getMonth(), n.getDate());
      return d.getTime() === today.getTime();
    },
    isFuture(d) {
      const n = new Date();
      const today = new Date(n.getFullYear(), n.getMonth(), n.getDate());
      return d.getTime() > today.getTime();
    },
    isSelected(d) {
      const s = this.selectedDate;
      return d.getFullYear() === s.getFullYear() && d.getMonth() === s.getMonth() && d.getDate() === s.getDate();
    },
    initDays() {
      const base = this.viewDate;
      const year = base.getFullYear();
      const month = base.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const arr = [];
      const today = new Date();
      const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      
      for (let i = 1; i <= daysInMonth; i++) {
        const d = new Date(year, month, i);
        if (d.getTime() <= todayDate.getTime()) {
          arr.push(d);
        }
      }
      this.days = arr;
      this.$nextTick(() => this.scrollToSelected('instant'))
    },
    selectDay(d) {
      if (this.isFuture(d)) return; // защита
      this.selectedDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      this.$nextTick(() => this.scrollToSelected('smooth'))
    },
    scrollLeft() {
      const el = this.$refs.scrollEl; if (!el) return;
      el.scrollBy({ left: -Math.max(240, el.clientWidth * 0.8), behavior: 'smooth' });
    },
    scrollRight() {
      const el = this.$refs.scrollEl; if (!el) return;
      el.scrollBy({ left: Math.max(240, el.clientWidth * 0.8), behavior: 'smooth' });
    },
    scrollToSelected(behavior = 'smooth') {
      const el = this.$refs.scrollEl; if (!el || !this.days.length) return;
      const idx = (this.selectedDate.getFullYear() === this.viewDate.getFullYear() && this.selectedDate.getMonth() === this.viewDate.getMonth())
        ? this.selectedDate.getDate() - 1 : 0;
      const child = el.children[idx];
      if (child) {
        const left = child.offsetLeft - 50;
        el.scrollTo({ left, behavior });
      }
    },
    prevMonth() {
      const d = this.viewDate
      const newView = new Date(d.getFullYear(), d.getMonth() - 1, 1)
      this.viewDate = newView
      this.selectedYear = newView.getFullYear()
      this.selectedMonth = newView.getMonth()
      this.applySafeSelectionForView(newView)
      this.initDays()
    },
    nextMonth() {
      const d = this.viewDate
      const newView = new Date(d.getFullYear(), d.getMonth() + 1, 1)
      this.viewDate = newView
      this.selectedYear = newView.getFullYear()
      this.selectedMonth = newView.getMonth()
      this.applySafeSelectionForView(newView)
      this.initDays()
    },
    onMonthYearChange() {
      const newView = new Date(this.selectedYear, this.selectedMonth, 1)
      this.viewDate = newView
      this.applySafeSelectionForView(newView)
      this.initDays()
    },
    applySafeSelectionForView(view) {
      const prevSelectedDay = this.selectedDate.getDate();
      const daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      const targetDay = Math.min(prevSelectedDay, daysInMonth);
      let candidate = new Date(view.getFullYear(), view.getMonth(), targetDay);
      const n = new Date();
      const today = new Date(n.getFullYear(), n.getMonth(), n.getDate());
      if (candidate.getTime() > today.getTime()) candidate = today;
      this.selectedDate = candidate;
    },
    async ensureBookId() {
      try {
        const book = await checkOrCreateBookByDate(this.selectedISO)
        // сохраняем и id, и полный контекст
        this.bookContext = book || null
        // backend может возвращать { id, date, ... } или { book: { id, date }, ... }
        this.bookId = book?.id || book?.book?.id || book || null
      } catch (e) {
        console.error('Calendar: ensureBookId failed', e)
        this.bookId = null
        this.bookContext = null
      }
    },
    // маппинг одного объекта orders_to_squads / chpo_orders_to_squads в строку 5-б раздела
    mapChpoSquadToOrderRow(it) {
      if (!it) return null
      // По ТЗ 02.09.2026: 5-б показывал ID-шники вместо ФИО ("34, 55" в mock, но
      // из ЧПГО приходили именно числа id). Собираем «л/н. звание Фамилия» —
      // как в исходной книге пограничной службы. chief идёт первым (старший ПН).
      const fmt = (u) => {
        if (!u) return ''
        const rank = u.rank ? String(u.rank).toLowerCase() + ' ' : ''
        // full_name бывает "Фамилия Имя Отчество" — берём фамилию + инициалы
        const nm = (u.full_name || '').trim().split(/\s+/).filter(Boolean)
        const surname = nm[0] || ''
        const initials = nm.slice(1).map(p => p ? p[0] + '.' : '').join('')
        const fio = surname ? `${surname}${initials ? ' ' + initials : ''}` : (u.full_name || '')
        const pn = u.personal_number != null && u.personal_number !== '' ? `№${u.personal_number} ` : ''
        return `${pn}${rank}${fio}`.trim()
      }
      const chief = it.chief || null
      const usersRaw = Array.isArray(it.users) ? it.users : []
      const members = chief ? [chief, ...usersRaw.filter(u => u && u.id !== chief.id)] : usersRaw
      const composition = members.map(fmt).filter(Boolean).join(', ')
      // Резервный вариант — если бекенд не отдал user-объекты (fallback на id).
      const fallbackIds = !composition && Array.isArray(it.users_ids) ? it.users_ids.join(', ') : ''
      const start = (it.start_time || '').slice(0,5)
      const end = (it.end_time || '').slice(0,5)
      return {
        id: it.id,
        chief_name: chief ? fmt(chief) : '',
        composition: composition || fallbackIds || (it.composition || ''),
        // По ТЗ 03.09.2026: «Виды п/н» — это КОД (squad_type: ПН/ППП/ЧП…),
        // а `order_type` — служебное поле «Переходящие наряды / Охрана НСОУ…»
        // (название секции плана). Fallback на order_type даёт мусор в 5-б.
        type: it.squad_type || '',
        reinforcement: it.reinforcement_means ?? '',
        area: [it.sector, it.ulitka].filter(Boolean).join(' / '),
        time: (start && end) ? `${start} - ${end}` : '',
        timeFrom: start || '',
        timeTo: end || '',
        editing: false,
      }
    },
    async fetchOrderPoints() {
      this.orderLoading = true
      this.orderError = null
      try {
        await this.ensureBookId()
        let squads = []
        if (this.bookContext) {
          // Берем данные из ответа book/check (chpo_orders_to_squads или orders_to_squads)
          const ctx = this.bookContext
          squads = ctx.chpo_orders_to_squads || ctx.orders_to_squads || []
        }
        
        this.orderRows = squads
          .map(sq => this.mapChpoSquadToOrderRow(sq))
          .filter(Boolean)
      } catch (e) {
        this.orderError = e?.message || String(e)
        console.error('Calendar: orderPoints load failed', e)
      } finally {
        this.orderLoading = false
      }
    },
    async fetchForces() {
      this.forcesLoading = true
      this.forcesError = null
      try {
        // По ТЗ 14.09.2026: числа 4 раздела должны быть «живыми», иначе
        // после чистки дублей BookUser или изменения BookUser.is_reinforcement
        // страница держит старые агрегаты из bookContexts (кэш http.js без TTL).
        invalidateBookContext(this.selectedISO)
        await this.ensureBookId()
        if (!this.bookContext || !this.bookContext.stats) {
          this.forcesRows = []
          return
        }
        
        const stats = this.bookContext.stats
        
        // Маппим stats в строки таблицы
        this.forcesRows = [
          {
            __id: 'in_house',
            group: this.$t('kps.calendar.groupByStaff'),
            values: {
              officers: stats.oficers?.in_house || 0,
              contract: stats.contracts?.in_house || 0,
              conscripts: stats.srochniki?.in_house || 0,
              workers: stats.workers?.in_house || 0,
              others: stats.others?.in_house || 0,
              // По ТЗ 03.09.2026: строка «По штату» должна показывать штатное
              // количество и для техники/животных, а не 0. Бэк отдаёт `in_house`
              // как active + archived для warehouse-моделей.
              dogs: stats.dogs?.in_house || 0,
              horses: stats.horses?.in_house || 0,
              vehicles: stats.military_technic?.in_house || 0,
              radars: stats.radio_stations?.in_house || 0,
              spots: stats.projectors?.in_house || 0,
              boats: stats.boats?.in_house || 0,
              optics: stats.devices?.in_house || 0,
              uav: stats.drones?.in_house || 0,
            },
            editing: false,
          },
          {
            __id: 'in_book',
            group: this.$t('kps.calendar.groupByList'),
            values: {
              officers: stats.oficers?.in_book || 0,
              contract: stats.contracts?.in_book || 0,
              conscripts: stats.srochniki?.in_book || 0,
              workers: stats.workers?.in_book || 0,
              others: stats.others?.in_book || 0,
              dogs: stats.dogs?.in_book || 0,
              horses: stats.horses?.in_book || 0,
              vehicles: stats.military_technic?.in_book || 0,
              radars: stats.radio_stations?.in_book || 0,
              spots: stats.projectors?.in_book || 0,
              boats: stats.boats?.in_book || 0,
              optics: stats.devices?.in_book || 0,
              uav: stats.drones?.in_book || 0,
            },
            editing: false,
          },
          {
            __id: 'archived',
            group: this.$t('kps.calendar.groupInReserve'),
            values: {
              officers: stats.oficers?.archived || 0,
              contract: stats.contracts?.archived || 0,
              conscripts: stats.srochniki?.archived || 0,
              workers: stats.workers?.archived || 0,
              others: stats.others?.archived || 0,
              dogs: stats.dogs?.archived || 0,
              horses: stats.horses?.archived || 0,
              vehicles: stats.military_technic?.archived || 0,
              radars: stats.radio_stations?.archived || 0,
              spots: stats.projectors?.archived || 0,
              boats: stats.boats?.archived || 0,
              optics: stats.devices?.archived || 0,
              uav: stats.drones?.archived || 0,
            },
            editing: false,
          },
          {
            __id: 'helped',
            group: this.$t('kps.calendar.groupOnReinforce'),
            values: {
              officers: stats.oficers?.helped || 0,
              contract: stats.contracts?.helped || 0,
              conscripts: stats.srochniki?.helped || 0,
              workers: stats.workers?.helped || 0,
              others: stats.others?.helped || 0,
              dogs: stats.dogs?.helped || 0,
              horses: stats.horses?.helped || 0,
              vehicles: stats.military_technic?.helped || 0,
              radars: stats.radio_stations?.helped || 0,
              spots: stats.projectors?.helped || 0,
              boats: stats.boats?.helped || 0,
              optics: stats.devices?.helped || 0,
              uav: stats.drones?.helped || 0,
            },
            editing: false,
          },
          {
            __id: 'total',
            group: this.$t('kps.calendar.groupTotal'),
            values: {
              officers: stats.oficers?.total || 0,
              contract: stats.contracts?.total || 0,
              conscripts: stats.srochniki?.total || 0,
              workers: stats.workers?.total || 0,
              others: stats.others?.total || 0,
              dogs: stats.dogs?.total || 0,
              horses: stats.horses?.total || 0,
              vehicles: stats.military_technic?.total || 0,
              radars: stats.radio_stations?.total || 0,
              spots: stats.projectors?.total || 0,
              boats: stats.boats?.total || 0,
              optics: stats.devices?.total || 0,
              uav: stats.drones?.total || 0,
            },
            editing: false,
          },
          {
            __id: 'total_used',
            group: this.$t('kps.calendar.groupUsed'),
            values: {
              officers: stats.oficers?.total_used || 0,
              contract: stats.contracts?.total_used || 0,
              conscripts: stats.srochniki?.total_used || 0,
              workers: stats.workers?.total_used || 0,
              others: stats.others?.total_used || 0,
              dogs: stats.dogs?.total_used || 0,
              horses: stats.horses?.total_used || 0,
              vehicles: stats.military_technic?.total_used || 0,
              radars: stats.radio_stations?.total_used || 0,
              spots: stats.projectors?.total_used || 0,
              boats: stats.boats?.total_used || 0,
              optics: stats.devices?.total_used || 0,
              uav: stats.drones?.total_used || 0,
            },
            editing: false,
          },
        ]
      } catch (e) {
        this.forcesError = e?.message || String(e)
        console.error('Calendar: forces load failed', e)
      } finally {
        this.forcesLoading = false
      }
    },
    async fetchBrief() {
      this.briefLoading = true
      this.briefError = null
      try {
        await this.ensureBookId()
        if (!this.bookId) return
        
        // Берем conclusion из контекста book/check
        const conclusion = this.bookContext?.conclusion
        if (conclusion) {
          this.briefId = conclusion.id
          this.briefTextArea = conclusion.text ?? this.briefTextArea
        } else {
          this.briefId = null
        }
      } catch (e) {
        this.briefError = e?.message || String(e)
        console.error('Calendar: brief load failed', e)
      } finally {
        this.briefLoading = false
      }
    },
    async fetchMileage() {
      this.mileageLoading = true
      this.mileageError = null
      try {
        await this.ensureBookId()
        if (!this.bookId) return
        
        // Загружаем список всех ТС и пайков для выпадающих списков
        try {
           const vList = await vehiclesApi.list()
           this.allVehicles = Array.isArray(vList) ? vList : []
        } catch(e) { console.error('Vehicles load error', e) }
        
        try {
           const mList = await mealsApi.list()
           this.allMeals = Array.isArray(mList) ? mList : []
        } catch(e) { console.error('Meals load error', e) }
        
        // Берем vehicle_records и meal_records из контекста book/check
        const runsRaw = this.bookContext?.vehicle_records || []
        const rations = this.bookContext?.meal_records || []

        // Отображаем ВСЕ транспортные средства
        this.runRows = this.allVehicles.map(veh => {
          // Ищем запись для этого ТС
          const record = runsRaw.find(r => {
            const rVehId = (typeof r.vehicle === 'object') ? r.vehicle.id : r.vehicle
            return rVehId === veh.id
          })

          return {
            id: record ? record.id : null, // ID записи (если есть)
            vehicleId: veh.id,
            type: veh.name || '',
            plate: veh.grnz || '',
            distance: record ? (record.odometr ?? 0) : 0,
            note: record ? (record.description ?? '') : '',
            vehicle_type: (veh.vehicle_type?.id ?? veh.vehicle_type) || null,
            editing: false,
          }
        })

        // Отображаем ВСЕ пайки
        this.rationRows = this.allMeals.map(meal => {
          // Ищем запись для этого пайка
          const record = rations.find(r => {
            const rMealId = (typeof r.meal === 'object') ? r.meal.id : r.meal
            return rMealId === meal.id
          })

          return {
            id: record ? record.id : null, // ID записи (если есть)
            name: meal.name,
            qty: record ? (record.quantity ?? record.qty ?? 0) : 0,
            mealId: meal.id,
            editing: false,
          }
        })
      } catch (e) {
        this.mileageError = e?.message || String(e)
        console.error('Calendar: mileage load failed', e)
      } finally {
        this.mileageLoading = false
      }
    },
    async fetchSection6() {
      this.sec6Loading = true
      this.sec6Error = null
      try {
        await this.ensureBookId()
        // Берем results из контекста book/check
        const list = this.bookContext?.results || []
        
        if (Array.isArray(list)) {
          this.sec6Entries = list.map(r => {
            // Извлекаем HH:MM из check_time (ISO datetime) или берём r.time
            let hhmm = null
            const ct = r.check_time || r.time
            if (typeof ct === 'string') {
              const m = ct.match(/T(\d{2}:\d{2})/)
              if (m) hhmm = m[1]
              else if (/^\d{2}:\d{2}/.test(ct)) hhmm = ct.slice(0,5)
            }
            // check_type может быть объектом {id, name} или просто id
            const typeId = r.check_type?.id ?? r.check_type_id ?? r.check_type
            
            return {
              id: r.id,
              checkTypeId: typeId ? Number(typeId) : null,
              time: hhmm,
              square: r.square ?? null,
              patrolType: r.border_patrol_type ?? r.patrol_type ?? r.patrolType ?? null,
              text: r.text ?? '',
              editing: false,
            }
          })
        } else {
          this.sec6Entries = []
        }
      } catch (e) {
        this.sec6Error = e?.message || String(e)
        console.error('Calendar: section6 load failed', e)
      } finally {
        this.sec6Loading = false
      }
    },

    // --- добавление строк в прочих секциях ---
    addForcesRow() {
      const row = {
        __id: 'fr-' + Date.now(),
        group: '',
        values: {
          officers: 0,
          contract: 0,
          conscripts: 0,
          workers: 0,
          dogs: 0,
          horses: 0,
          vehicles: 0,
          radars: 0,
          spots: 0,
          boats: 0,
          optics: 0,
          uav: 0,
        },
        editing: true,
      }
      this.forcesRows = [...this.forcesRows, row]
    },
    addOrderRow() {
      const row = {
        __id: 'ord-' + Date.now(),
        composition: '',
        type: '',
        reinforcement: '',
        area: '',
        timeFrom: '',
        timeTo: '',
        time: '',
        editing: true,
      }
      this.orderRows = [...this.orderRows, row]
    },
    addRunRow() {
      const row = {
        __id: 'run-' + Date.now(),
        type: '',
        plate: '',
        distance: 0,
        note: '',
        editing: true,
      }
      this.runRows = [...this.runRows, row]
    },
    addRationRow() {
      const row = {
        __id: 'ration-' + Date.now(),
        name: '',
        qty: 0,
        editing: true,
      }
      this.rationRows = [...this.rationRows, row]
    },

    // --- редактирование 5-а (краткие выводы) ---
    startEditBrief() {
      this.briefBackup = this.briefTextArea
      this.briefEditing = true
    },
    async saveBrief() {
      try {
        await this.ensureBookId()
        if (!this.bookId) throw new Error(this.$t('kps.calendar.bookNotDefined'))
        if (this.briefId) {
          await updateConclusion(this.briefId, { text: this.briefTextArea })
        } else {
          const created = await createConclusion({ book: this.bookId, text: this.briefTextArea })
          if (created && created.id) this.briefId = created.id
        }
        this.briefEditing = false
        this.briefBackup = ''
      } catch (e) {
        alert(this.$t('common.saveFailed') + ': ' + (e?.message || e))
        console.error('Calendar: brief save failed', e)
      }
    },
    cancelBrief() {
      this.briefTextArea = this.briefBackup
      this.briefEditing = false
      this.briefBackup = ''
    },

    // --- общий паттерн редактирования для таблиц ---
    onEdit(row, listKey) {
      row.__backup = JSON.parse(JSON.stringify(row))
      row.editing = true
      if (listKey === 'orderRows') {
        if (!row.timeFrom || !row.timeTo) {
          const m = (row.time || '').match(/^(\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})$/)
          if (m) { row.timeFrom = m[1]; row.timeTo = m[2] }
        }
      }
    },
    async onAccept(row, listKey) {
      try {
        await this.ensureBookId()
        if (!this.bookId) throw new Error(this.$t('kps.calendar.bookNotDefined'))
        if (listKey === 'orderRows') {
          // Мэппинг в CHPO payload. Состав ПН формируется в плане охраны
          // (/chpo/plan) — здесь только метаданные (тип/усиление/участок/время).
          // По ТЗ 02.09.2026: если composition содержит числа (id-шники), поддерживаем
          // обратную совместимость и парсим их; для форматированной строки
          // "№34 л-т Иванов" — не трогаем users_ids на бэке.
          const tf = (row.timeFrom || '').trim(); const tt = (row.timeTo || '').trim()
          const parseUsers = (txt) => {
            if (!txt) return []
            return String(txt)
              .split(/[,;\s]+/)
              .map(s => s.trim())
              .filter(Boolean)
              .map(x => Number(x))
              .filter(n => Number.isFinite(n))
          }
          // Разбиваем "sector / улитка" обратно на два поля если было слитно
          const areaParts = String(row.area || '').split('/').map(s => s.trim()).filter(Boolean)
          const payload = {
            squad_type: row.type || '',
            reinforcement_means: row.reinforcement || '',
            sector: areaParts[0] || '',
            ulitka: (areaParts[1] || '').toUpperCase().slice(0, 16),
            start_time: tf ? (tf.length === 5 ? `${tf}:00` : tf) : null,
            end_time: tt ? (tt.length === 5 ? `${tt}:00` : tt) : null,
          }
          const users_ids = parseUsers(row.composition)
          if (users_ids.length) {
            payload.chief_id = users_ids[0]
            payload.users_ids = users_ids.slice(1)
          }
          if (row.id) {
            await updateChpoOrderToSquad(row.id, payload)
          } else {
            const created = await createChpoOrderToSquad(payload)
            if (created && created.id) row.id = created.id
          }
        } else if (listKey === 'runRows') {
          // Логика: ищем ТС по гос. номеру (среди загруженных allVehicles).
          // Если нет - создаем новое ТС (имя = гос. номер).
          // Затем создаем или обновляем vehicle_record.
          
          let vehicleId = row.vehicleId
          const plate = (row.plate || '').trim()
          
          // Если vehicleId нет (новая строка), пробуем найти или создать
          if (!vehicleId) {
             if (!plate) throw new Error(this.$t('kps.calendar.plateNotFilled'))
             const existingV = this.allVehicles.find(v => (v.grnz || '').toLowerCase() === plate.toLowerCase())
             if (existingV) {
               vehicleId = existingV.id
             } else {
               const newV = await vehiclesApi.create({
                 name: plate,
                 grnz: plate,
                 vehicle_type: row.vehicle_type
               })
               if (newV && newV.id) {
                 vehicleId = newV.id
                 this.allVehicles.push(newV)
               }
             }
          }
          
          if (!vehicleId) throw new Error(this.$t('kps.calendar.vehicleNotResolved'))
          
          const payload = {
            book: this.bookId,
            vehicle: vehicleId,
            odometr: String(row.distance ?? '0'),
            description: row.note || ''
          }
          
          if (row.id) {
            // Если есть ID записи - обновляем её (PATCH)
            await updateVehicleRecord(row.id, payload)
          } else {
            // Если нет ID - создаем новую (POST)
            const created = await createVehicleRecord(payload)
            if (created && created.id) row.id = created.id
          }
          
          row.vehicleId = vehicleId
        } else if (listKey === 'rationRows') {
          // Логика: если есть ID записи - обновляем, если нет - создаем (POST)
          if (!row.mealId) throw new Error(this.$t('kps.calendar.mealNotChosen'))
          
          const payload = { 
            book: this.bookId,
            meal: row.mealId, 
            quantity: Number(row.qty || 0) 
          }

          if (row.id) {
             await updateMealRecord(row.id, payload)
          } else {
             const created = await createMealRecord(payload)
             if (created && created.id) row.id = created.id
          }
          
          // Обновляем отображаемое имя
          const meal = this.allMeals.find(m => m.id === row.mealId)
          if (meal) row.name = meal.name
        } else if (listKey === 'forcesRows') {
          // API отключён – просто принимаем изменения локально
        }
        row.editing = false
        delete row.__backup
        if (listKey === 'orderRows') {
          const tf = (row.timeFrom || '').trim(); const tt = (row.timeTo || '').trim(); if (tf && tt) row.time = `${tf} - ${tt}`
        }
      } catch (e) {
        alert(this.$t('common.saveFailed') + ': ' + (e?.message || e))
        console.error('Calendar: row save failed', e)
      }
    },
    


    onDecline(row) {
      if (row.__backup) {
        const b = row.__backup
        Object.keys(b).forEach(k => { if (k !== '__backup') row[k] = b[k] })
        delete row.__backup
      }
      row.editing = false
    },
    async onDelete(row, listKey) {
      const arr = this[listKey]
      if (!Array.isArray(arr)) return
      const id = row.__id ?? row.id
      if (!row.id) {
        const idx = arr.findIndex(r => (r.__id ?? r.id) === id)
        if (idx !== -1) this[listKey] = [...arr.slice(0, idx), ...arr.slice(idx + 1)]
        return
      }
      try {
        await this.ensureBookId()
        if (listKey === 'orderRows') {
          await deleteChpoOrderToSquad(row.id)
        } else if (listKey === 'runRows') {
          await deleteVehicleRecord(row.id)
        } else if (listKey === 'rationRows') {
          await deleteMealRecord(row.id)
        } else if (listKey === 'forcesRows') {
          // API отключён – удаляем локально, без запроса
        }
        const idx = arr.findIndex(r => (r.__id ?? r.id) === id)
        if (idx !== -1) this[listKey] = [...arr.slice(0, idx), ...arr.slice(idx + 1)]
      } catch (e) {
        alert(this.$t('common.deleteFailed') + ': ' + (e?.message || e))
        console.error('Calendar: row delete failed', e)
      }
    },

    // CRUD секции 6 (без табов)
    addSec6Entry() {
      if (!this.canEditSec6) return
      const row = { __id: 's6e-' + Date.now(), checkType: null, time: null, square: null, patrolType: null, text: '', editing: true }
      this.sec6Entries = [row, ...this.sec6Entries]
    },
    startEditSec6Entry(entry) {
      if (!this.canEditSec6) return
      entry.__backup = JSON.parse(JSON.stringify(entry));
      entry.editing = true
    },
    async saveSec6Entry(entry) {
      if (!this.canEditSec6) return
      try {
        entry.saving = true
        // Перед сохранением убедимся что time в формате HH:MM
        if (entry.time && /^\d{1}:\d{2}$/.test(entry.time)) {
          const parts = entry.time.split(':'); entry.time = parts[0].padStart(2,'0') + ':' + parts[1]
        }
        const saved = await saveSection6Entry(this.selectedISO, entry)
        if (!entry.id && saved && saved.id) entry.id = saved.id
        // Обновим checkTypeId из ответа если backend вернул
        if (saved?.check_type_id) entry.checkTypeId = saved.check_type_id
        // Нормализуем время обратно
        if (saved?.check_time) {
          const m = String(saved.check_time).match(/T(\d{2}:\d{2})/); if (m) entry.time = m[1]
        }
        entry.editing = false
        delete entry.__backup
      } catch (e) {
        alert(this.$t('common.saveFailed') + ': ' + (e?.message || e))
        console.error('Calendar: sec6 save failed', e)
      } finally {
        entry.saving = false
      }
    },
    cancelSec6Entry(entry) {
      if (entry.__backup) {
        const b = entry.__backup
        Object.keys(b).forEach(k => { if (k !== '__backup') entry[k] = b[k] })
        delete entry.__backup
      }
      entry.editing = false
    },
    async onDeleteSec6Entry(entry) {
      if (!this.canEditSec6) return
      const id = entry.__id ?? entry.id
      if (!id) {
        this.sec6Entries = this.sec6Entries.filter(e => (e.__id ?? e.id) !== id)
        return
      }
      try {
        entry.saving = true
        await deleteSection6Entry(this.selectedISO, entry.id)
        this.sec6Entries = this.sec6Entries.filter(e => (e.__id ?? e.id) !== id)
      } catch (e) {
        alert(this.$t('common.deleteFailed') + ': ' + (e?.message || e))
        console.error('Calendar: sec6 delete failed', e)
      } finally {
        entry.saving = false
      }
    },

    getOptionLabel(options, value) {
      const o = (options || []).find(x => x.value === value)
      return o ? o.label : ''
    },

    // --- утилиты ---
    formatDateRU(d) {
      const two = (n) => (n < 10 ? `0${n}` : String(n))
      return `${two(d.getDate())}.${two(d.getMonth()+1)}.${d.getFullYear()}`
    },
    orderRowHeight(row) { return row && row.editing ? 96 : 56 },
  }
}
</script>

<style scoped>
.page {
  background: #FFFFFF;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.page__title { margin: 0; color: #111827; font-size: 24px; font-weight: 700; line-height: 33.6px; }

.month-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.month-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.month-select,
.year-select {
  height: 32px;
  border-radius: 8px;
  border: 1px solid #D1D5DB;
  padding: 0 8px;
  font-size: 13px;
  background: #FFFFFF;
}

.days-bar { position: relative; display: grid; grid-template-columns: auto 1fr auto; align-items: center; gap: 8px; }
.nav { width: 36px; height: 36px; border: none; border-radius: 8px; background: #F3F4F6; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; }
.nav:hover { background: #E5E7EB; }
.nav__icon { width: 18px; height: 18px; display: block; }
.nav__icon--right { transform: rotate(180deg); }

.days-scroll { overflow-x: auto; overflow-y: hidden; display: flex; align-items: stretch; gap: 8px; padding: 8px 16px; scroll-behavior: smooth; }
.days-scroll::-webkit-scrollbar { height: 6px; }
.days-scroll::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 4px; }

.day { min-width: 64px; max-width: 64px; height: 64px; border-radius: 12px; background: #FFFFFF; outline: 1px #E9EAEC solid; outline-offset: -1px; display: grid; grid-template-rows: 1fr auto; align-items: center; justify-items: center; padding: 6px 8px; box-sizing: border-box; cursor: pointer; }
.day:hover { background: #F9FAFB; }
.day__num { color: #111827; font-size: 18px; font-weight: 700; }
.day__weekday { color: #6B7280; font-size: 12px; line-height: 16px; }
.day.today { background: #F0FDF4; outline-color: #86EFAC; }
.day.selected { background: #2A8A1B; outline-color: #2A8A1B; }
.day.selected .day__num, .day.selected .day__weekday { color: #FFFFFF; }


.day--disabled { opacity: 0.45; cursor: not-allowed; }
.day--disabled:hover { background: #FFFFFF; }

.page__content { min-height: 200px; }
.muted { color: #6B7280; margin: 0; }
.page__footer { display: flex; justify-content: flex-end; margin-top: auto; }

.section-tabs { display: inline-flex; gap: 8px; padding: 12px 0 4px; flex-wrap: wrap; }
.section-tabs__btn { border: 1px solid #E5E7EB; background: #fff; color: #111827; border-radius: 8px; padding: 8px 14px; cursor: pointer; font-size: 14px; font-weight: 600; }
.section-tabs__btn:hover { background: #F9FAFB; }
.section-tabs__btn.is-active { background: #2F78EE; color: #fff; border-color: #2F78EE; }

.section-card { position: relative; background: #FFFFFF; border-radius: 16px; padding: 24px 16px; box-sizing: border-box; margin-top: 8px; outline: 1px #E9EAEC solid; outline-offset: -1px; }
.section-header { display: flex; align-items: center; gap: 20px; }
.section-title { margin: 0; color: #111827; font-size: 24px; font-weight: 700; line-height: 31.2px; }
.section-body { margin-top: 8px; }
.error { color: #D81717; margin: 0; }


.cell-text { flex: 1 1 0; color: #111827; font-size: 16px; line-height: 20px; width: 100%; }
.tbl-input { width: 100%; height: 32px; padding: 6px 10px; border: 1px solid #E5E7EB; border-radius: 8px; font-size: 16px; line-height: 20px; font-family: 'Times New Roman', Times, serif; color: #111827; background: #fff; }
.tbl-input:focus { outline: 2px solid rgba(47,120,238,.25); outline-offset: 0; }


.actions { display: inline-flex; align-items: center; gap: 10px; justify-content: flex-end; width: 100%; }
.actions__btn { width: 30px; height: 30px; padding: 6px; border-radius: 8px; border: 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.actions__icon { width: 16px; height: 16px; display: block; }
.actions__btn--edit    { background: #2F78EE; }
.actions__btn--accept  { background: #2A8A1B; }
.actions__btn--decline { background: #D81717; }
.actions__btn--delete  { background: #D81717; }


.brief-editor { display: grid; gap: 8px; }
.brief-view { margin: 0; white-space: pre-wrap; font-family: 'Times New Roman', Times, serif; font-size: 20px; line-height: 24px; color: #111827; }
.brief-textarea { width: 100%; min-height: 160px; padding: 10px 12px; border: 1px solid #E5E7EB; border-radius: 8px; font-size: 20px; line-height: 24px; font-family: 'Times New Roman', Times, serif; color: #111827; background: #fff; resize: vertical; }
.brief-actions { display: inline-flex; gap: 8px; }

.sec6-list { display: grid; gap: 12px; }
.sec6-entry { background: #FFFFFF; border-radius: 16px; outline-offset: -1px; padding: 24px; display: flex; flex-direction: column; gap: 20px; }

.sec6-entry__top { 
  display: grid; 
  grid-template-columns: repeat(3, 1fr) 160px; 
  gap: 10px; 
  align-items: stretch; 
}
.sec6-entry__field { display: flex; flex-direction: column; }

/* Override SelectField to match view mode box */
.sec6-entry__field :deep(.select__control) {
  min-height: 54px;
  border-radius: 10px;
  border: 1px solid #E9EAEC;
  padding: 16px 20px;
  box-shadow: none;
  background: #fff;
}
.sec6-entry__field :deep(.select__input) {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  font-family: inherit; 
}
.sec6-entry__field :deep(.select.is-open .select__control) {
  border-color: #C3D0F7;
  box-shadow: 0 0 0 2px rgba(47,120,238,.2);
}

.sec6-field-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-radius: 10px;
  outline: 1px solid #E9EAEC;
  outline-offset: -1px;
  background: #fff;
  min-height: 54px;
  box-sizing: border-box;
}
.sec6-field-box__text {
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
}
.sec6-field-box__icon {
  width: 20px; 
  height: 20px; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  opacity: 0.5;
}
.sec6-field-box__icon::after {
  content: '';
  width: 10px;
  height: 6px;
  background-color: #111827;
  clip-path: polygon(100% 0%, 0 0%, 50% 100%);
}


.sec6-time-select { min-width: 120px; }

.sec6-entry__bottom { display: flex; gap: 12px; align-items: flex-start; }
.sec6-entry__bottom .brief-view { 
  flex: 1; 
  min-width: 0; 
  margin-top: 0 !important; 
  width: auto !important;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  
  color: #000000;
  font-size: 18px;
  font-weight: 400;
  line-height: 23.4px;
  font-family: 'Times New Roman', Times, serif;
}
.sec6-entry__bottom .brief-textarea { 
  flex: 1; 
  min-width: 0; 
  font-family: 'Times New Roman', Times, serif;
}

.sec6-entry__bottom-actions {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-shrink: 0; 
}

.time-range {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.time-field {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6B7280;
  width: 100%;
}
.time-field span {
  min-width: 16px;
}
.time-field :deep(.tbl-input) {
  flex: 1;
  min-width: 0;
  text-align: center;
}
</style>
